import { stats } from '@fiverr-private/obs';

const METRIC_PREFIX = 'packages.listings';

export const metric = stats.prefix(METRIC_PREFIX);
